<!-- eslint-disable prettier/prettier -->
<template>
  <div id="app">
    <div
      v-if="show && $store.state.loading"
      :class="[{ el: !$store.state.loading }, 'main-loader']"
      @transitionend="onTransitionEnd"
    >
    
      <div>
        <img src="./assets/img/wizztech-mark.png" alt="Logo" style="width: 48px"/>
        <!-- <img
          src="./assets/img/forgedrift-icon.png"
          alt="Logo"
          style="width: 48px"
        /> -->
      </div>
    </div>
    <div>
      <AppHeader />
      <div class="main">
        <router-view />
        <AppFooter />
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable prettier/prettier -->
<script>
import AppHeader from "@/components/header/AppHeader";
import AppFooter from "@/components/footer/AppFooter";
export default {
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      show: true,
    };
  },
  created() {
    this.restoreCachedWizzData();
    this.getWizzData();
    this.$store.dispatch("setTranslations");
  },
  async mounted() {
    const { localizePage } = await import("@/services/localizePage");
    if (this.$el?.isConnected) {
      this.stopLocalization = localizePage(this.$store);
    }
  },
  beforeUnmount() {
    if (this.stopLocalization) this.stopLocalization();
  },

  methods: {
    onTransitionEnd() {
      this.show = false;
    },
    restoreCachedWizzData() {
      const cachedWizzData = localStorage.getItem("wizzData");

      if (!cachedWizzData) return;

      try {
        const response = JSON.parse(cachedWizzData);
        const lang = localStorage.getItem("lang") || "en";

        this.$store.commit("setTranslationData", response);
        this.$store.dispatch("setLanguage", lang);
      } catch (error) {
        localStorage.removeItem("wizzData");
      }
    },
    getWizzData() {
      this.$store.commit("setLoading", false);
      fetch(
        "https://script.google.com/macros/s/AKfycbzaZUjZ4Ppg8FUqLxhWhMVqzThnaRcmmog1_Lkp_pbSm2aJAdtYDDaN7yUWBsz1EmiE/exec"
      )
        .then((res) => res.json())
        .then((response) => {
          localStorage.setItem("wizzData", JSON.stringify(response));
          this.$store.commit("setTranslationData", response);
          this.$store.commit("setLoading", false);
          const lang = localStorage.getItem("lang");
          this.$store.dispatch("setLanguage", lang || "en");
          if (!lang) {
            window?.languageChange();
          }
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
};
</script>
<!-- eslint-disable prettier/prettier -->
<style>
.el {
  opacity: 0 !important;
}

#app {
  margin: 0;
  font-family: "Inter", sans-serif;
  color: #282c3f;
}
body {
  margin: 0;
}
</style>
